
import { Game } from "@/models/Game";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
class GameStatus extends Vue {
  @Prop({ default: null }) readonly data!: Game;

  get getPreAppLaunch(): number {
    return this.$store.state.authenication.appPrelaunch._value;
  }

  getStatusCSS(): string {
    var now = new Date();
    var startDate = new Date(this.data.start_dt).toISOString();
    var endDate = new Date(this.data.end_dt).toISOString();
    var currentDate = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    var preLaunchDate = new Date(
      new Date(this.data.start_dt).getTime() -
        this.getPreAppLaunch * 60000 -
        new Date(this.data.start_dt).getTimezoneOffset() * 60000
    ).toISOString();
    if (this.data.template) {
      return "games-template-status";
    }
    if (
      !this.data.template &&
      !this.data.live &&
      startDate > currentDate &&
      endDate > currentDate
    ) {
      return "games-wip-status";
    }
    if (
      !this.data.template &&
      this.data.live &&
      currentDate >= preLaunchDate &&
      startDate >= currentDate
    ) {
      return "games-live-status";
    }
    if (
      !this.data.template &&
      this.data.live &&
      startDate <= currentDate &&
      endDate > currentDate
    ) {
      return "games-live-status";
    }
    if (
      !this.data.template &&
      this.data.live &&
      startDate >= currentDate &&
      currentDate <= preLaunchDate
    ) {
      return "games-published-status";
    }
    if (
      !this.data.template &&
      this.data.live &&
      startDate <= currentDate &&
      endDate <= currentDate
    ) {
      return "games-end-status";
    }
    if (
      !this.data.template &&
      !this.data.live &&
      startDate <= currentDate &&
      endDate <= currentDate
    ) {
      return "games-purge-status";
    }
    return "games-wip-status";
  }

  getStatus(): string {
    var now = new Date();
    var startDate = new Date(this.data.start_dt).toISOString();
    var endDate = new Date(this.data.end_dt).toISOString();
    var currentDate = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    var preLaunchDate = new Date(
      new Date(this.data.start_dt).getTime() -
        this.getPreAppLaunch * 60000 -
        new Date(this.data.start_dt).getTimezoneOffset() * 60000
    ).toISOString();
    if (this.data.template) {
      return "TEMPLATE";
    }
    if (
      this.data.live &&
      currentDate >= preLaunchDate &&
      startDate >= currentDate
    ) {
      return "OPEN";
    }

    if (this.data.live && startDate <= currentDate && endDate > currentDate) {
      return "LIVE";
    }
    if (
      this.data.live &&
      startDate >= currentDate &&
      currentDate <= preLaunchDate
    ) {
      return "PUBLISHED";
    }
    if (this.data.live && startDate <= currentDate && endDate <= currentDate) {
      return "ENDED";
    }
    if (!this.data.live && startDate <= currentDate && endDate <= currentDate) {
      return "PURGING";
    }
    return "WIP";
  }
}

export default GameStatus;
